import React, { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
        // Start blinking after 2 seconds of being visible
        setTimeout(() => {
          setIsBlinking(true);
        }, 2000);
      } else {
        setIsVisible(false);
        setIsBlinking(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className={`
            fixed bottom-8 right-8 z-50 
            bg-gradient-to-r from-green-500 to-green-600 
            hover:from-green-600 hover:to-green-700 
            text-white p-4 rounded-full 
            shadow-lg hover:shadow-xl 
            transition-all duration-300 
            transform hover:scale-110 
            group
            ${isBlinking ? 'animate-pulse' : ''}
          `}
          aria-label="Back to top"
        >
          <ChevronUp 
            size={24} 
            className="transform transition-transform duration-300 group-hover:-translate-y-1" 
          />
          <div className="absolute inset-0 bg-white/20 rounded-full animate-ping opacity-75"></div>
        </button>
      )}
    </>
  );
};

export default BackToTop;
